<template>
  <div class="HotelCertification">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
data(){
    return{

    }
}
}
</script>

<style lang="scss" scoped>
.HotelCertification{
    width: 100%;
    height: 100%;
    background: url('../../../static/image/account/bg.png') no-repeat center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.HotelCertification /deep/ .el-input input::-webkit-input-placeholder {
  color:#AAAAAA;
  font-size: 16px;
}
.HotelCertification /deep/ .el-input input::-moz-input-placeholder {
  color:#AAAAAA;
  font-size: 16px;
}
.HotelCertification /deep/ .el-input input::-ms-input-placeholder {
  color:#AAAAAA;
  font-size: 16px;
}
.HotelCertification /deep/ .el-dialog {
  width: 1000px;
  padding: 0 30px;
  
border-radius: 20px;
}
.HotelCertification /deep/.el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
}
.HotelCertification /deep/.el-dialog__header {
  padding-top: 40px;
}
.HotelCertification /deep/.el-dialog__title {
  font-size: 24px;
  color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/views/HotelCertification/index.vue